import { FormatColorResetOutlined, WaterDrop } from '@mui/icons-material'
import { useTheme } from '@mui/material'

const LeakItem = ({ value }: { value: number }) => {
  const theme = useTheme()

  const { ariaLabel, iconColor, IconComponent } = {
    0: { ariaLabel: 'No water', iconColor: theme.palette.ui.outlineVariant, IconComponent: FormatColorResetOutlined },
    1: { ariaLabel: 'Water detected', iconColor: theme.palette.info.main, IconComponent: WaterDrop },
  }[value] ?? { ariaLabel: 'Unknown', iconColor: theme.palette.text.primary, IconComponent: () => <>-</> }

  return <IconComponent htmlColor={iconColor} aria-label={ariaLabel} />
}

export default LeakItem
